<script>
    import { PageLoading } from "../../../Components/Common/index.svelte";

    import { unknownPatientInsuranceType } from "../../../Utils/utilConstants.svelte";

    import {
        getBoolean,
        getInsuranceType,
        getText,
        isObjectEmpty,
    } from "../../../Utils/utilFunctions.svelte";

    import {
        cacheTrafficAccidentAuthorities,
        cacheWorkersCompensation,
    } from "../../../Utils/utilCache.svelte";

    import {
        trafficAccidentAuthorities,
        workersCompensation,
    } from "../../../stores";

    import { PatientInsuranceDetailsDisplayContent as DisplayContent } from "./helperComponent.svelte";

    import { syncPatientInsuranceDetails } from "../helpers/encounterHelper.svelte";

    export let patientDetails = {};
    export let patientEncounter = {};

    $: insuranceType =
        syncPatientInsuranceDetails(patientEncounter)?.insuranceType ??
        unknownPatientInsuranceType;

    $: if (insuranceType == 16) loadWorkCoverData();

    $: if (insuranceType == 17) loadTrafficAccidentData();

    $: if (insuranceType == 18)
        tppData = { ...patientEncounter.patientEncounterThirdPartyInsurerData };

    $: if (insuranceType == 25 || insuranceType == 26) syncDefenceData();

    $: if (insuranceType == 30) syncPipData();

    let workCoverData = {},
        isLoadingWorkCoverData = false;

    let trafficAccidentData = {},
        isLoadingTrafficAuthorities = false;

    let defenceData = {},
        isSyncingDefenceData = false;

    let pipData = {},
        isSyncingPipData = false;

    let tppData = {};

    const loadWorkCoverData = async () => {
        isLoadingWorkCoverData = true;

        await cacheWorkersCompensation();

        const { patientEncounterWorkCoverData } = patientEncounter;
        const { insurance } = patientDetails;

        if (
            patientEncounterWorkCoverData &&
            patientEncounterWorkCoverData.workCoverAuthority
        )
            workCoverData = $workersCompensation.find(
                (compensation) =>
                    compensation.id ==
                    patientEncounterWorkCoverData.workCoverAuthority,
            );

        if (workCoverData && !isObjectEmpty(workCoverData))
            workCoverData = {
                ...patientEncounterWorkCoverData,
                email: patientEncounterWorkCoverData?.email ?? "",
                claimNo: patientEncounterWorkCoverData?.claimId ?? "",
                name: workCoverData.name,
                state: workCoverData.state,
            };
        else {
            const employerDetails = insurance ? insurance.split("|") : [];

            if (employerDetails.length) {
                workCoverData.employer = employerDetails[0] ?? "";
                workCoverData.employerEmail = employerDetails[1] ?? "";
                workCoverData.claimNo = employerDetails[2] ?? "";
            }
        }

        // workCoverData = {
        //     ...workCoverData,
        //     email: patientEncounterWorkCoverData?.email ?? "",
        //     claimId: patientEncounterWorkCoverData?.claimId ?? "",
        // };

        // const employerDetails = insurance ? insurance.split("|") : [];

        // if (employerDetails.length) {
        //     workCoverData.employer = employerDetails[0] ?? "";
        //     workCoverData.employerEmail = employerDetails[1] ?? "";
        //     workCoverData.claimNo = employerDetails[2] ?? "";
        // }

        isLoadingWorkCoverData = false;
    };

    const loadTrafficAccidentData = async () => {
        isLoadingTrafficAuthorities = true;

        await cacheTrafficAccidentAuthorities();

        const { patientEncounterTrafficAccidentData } = patientEncounter;
        const { insurance } = patientDetails;

        if (patientEncounterTrafficAccidentData)
            trafficAccidentData = $trafficAccidentAuthorities.find(
                (authority) =>
                    authority.id ==
                    patientEncounterTrafficAccidentData.trafficAccidentAuthority,
            );

        if (insurance && trafficAccidentData)
            trafficAccidentData.claimNo = insurance;

        isLoadingTrafficAuthorities = false;
    };

    const syncDefenceData = async () => {
        isSyncingDefenceData = true;

        const { patientEncounterDefenceData } = patientEncounter;

        if (patientEncounterDefenceData) defenceData = { ...patientEncounterDefenceData };
        else {
            const { insurance } = patientDetails;

            const insuranceDetails = insurance.split("|");

            if (insuranceDetails.length) {
                defenceData.pid = insuranceDetails[0] ?? "";
                defenceData.dan = insuranceDetails[1] ?? "";
            }
        }

        isSyncingDefenceData = false;
    };

    const syncPipData = async () => {
        isSyncingPipData = true;

        const { patientEncounterPIPData } = patientEncounter;

        if (patientEncounterPIPData) pipData = { ...patientEncounterPIPData };
        else {
            const { insurance } = patientDetails;

            const insuranceDetails = insurance.split("|");

            if (insuranceDetails.length) {
                pipData.email = insuranceDetails[0] ?? "";
                pipData.vendorNumbers = insuranceDetails[1] ?? "";
            }
        }

        isSyncingPipData = false;
    };

    const getPatientCoverType = (coverType) => {
        if (!coverType || typeof coverType !== "string") return "-";
        switch (coverType?.toLowerCase()) {
            case "top cover":
                return "Top Cover Gold (AMA RVGs)";
            case "normal cover":
                return "Prime Choice Gold (AHSA RVGs)";
            default:
                return coverType;
        }
    };
</script>

<div class="flex flex-col flex-1 gap-y-4">
    <DisplayContent
        title="Insurance Type"
        content={getInsuranceType(insuranceType)}
    />

    {#if insuranceType == unknownPatientInsuranceType}
        <div class="flex flex-1 w-full">No insurance details.</div>
    {:else if insuranceType == 10}
        <DisplayContent
            title="Insurance Details"
            content={getText(patientDetails.insurance, "-")}
        />
        <DisplayContent
            title="Overseas Fund"
            content={getText(patientDetails.insuranceName, "-")}
        />
        <DisplayContent
            title="Membership No."
            content={getText(patientDetails.membershipNo, "-")}
        />
        <DisplayContent
            title="Membership Ref No."
            content={getText(patientDetails.membershipRefNo, "-")}
        />
    {:else}
        {#if insuranceType != 18}
            <DisplayContent
                title="Medicare No."
                content={getText(patientDetails.medicareNo, "-")}
            />
            <DisplayContent
                title="Medicare Ref No."
                content={getText(patientDetails.medicareRefNo, "-")}
            />
        {/if}

        {#if insuranceType == 0}
            <DisplayContent
                title="Health Fund"
                content={getText(patientDetails.insuranceName, "-")}
            />
            <DisplayContent
                title="Cover Type"
                content={patientDetails.insurance
                    ? getPatientCoverType(patientDetails.insurance)
                    : "-"}
                showContent={patientDetails.showFundCoverType}
            />
            <DisplayContent
                title="Membership No."
                content={getText(patientDetails.membershipNo, "-")}
            />
            <DisplayContent
                title="Membership Ref No."
                content={getText(patientDetails.membershipRefNo, "-")}
            />
        {:else if insuranceType == 16}
            {#if isLoadingWorkCoverData}
                <PageLoading />
            {:else if isObjectEmpty(workCoverData)}
                <div class="flex flex-1 w-full">Missing Work Cover Data.</div>
            {:else}
                <DisplayContent
                    title="Work Cover Name"
                    content={getText(workCoverData.name, "-")}
                />
                <DisplayContent
                    title="State"
                    content={getText(workCoverData.state, "-")}
                />
                <DisplayContent
                    title="Email"
                    content={getText(workCoverData.email, "-")}
                />
                <DisplayContent
                    title="Claim No."
                    content={getText(workCoverData.claimNo, "-")}
                />
                <DisplayContent
                    title="Employer"
                    content={getText(workCoverData.employer, "-")}
                />
                <DisplayContent
                    title="Employer Email"
                    content={getText(
                        workCoverData.employerEmail?.replaceAll(" ", ""),
                        "-",
                    )}
                />
            {/if}
        {:else if insuranceType == 17}
            {#if isLoadingTrafficAuthorities}
                <PageLoading />
            {:else if isObjectEmpty(trafficAccidentData)}
                <div class="flex flex-1 w-full">
                    Missing Traffic Accident Authority Data.
                </div>
            {:else}
                <DisplayContent
                    title="Authority Name"
                    content={getText(trafficAccidentData.name, "-")}
                />
                <DisplayContent
                    title="State"
                    content={getText(trafficAccidentData.state, "-")}
                />
                <DisplayContent
                    title="Email"
                    content={getText(trafficAccidentData.email, "-")}
                />
                <DisplayContent
                    title="Claim No."
                    content={getText(trafficAccidentData.claimNo, "-")}
                />
            {/if}
        {:else if insuranceType == 18}
            {#if !tppData || isObjectEmpty(tppData)}
                <p class="flex flex-1 w-full">
                    Missing Third Party Authority Data.
                </p>
            {:else}
                <DisplayContent
                    title="Payer Name"
                    content={getText(tppData.name, "-")}
                />
                <DisplayContent
                    title="Payer Address"
                    content={getText(tppData.address, "-")}
                />
                <DisplayContent
                    title="Payer Email"
                    content={getText(tppData.email, "-")}
                />
                <DisplayContent
                    title="Payer Phone No."
                    content={getText(tppData.phone, "-")}
                />
                <DisplayContent
                    title="Add GST"
                    content={getBoolean(tppData.addGST)}
                />
            {/if}
        {:else if insuranceType == 20}
            <DisplayContent
                title="Veteran No."
                content={getText(patientDetails.veteranNo, "-")}
            />
        {:else if insuranceType == 25 || insuranceType == 26}
            {#if isSyncingDefenceData}
                <PageLoading />
            {:else if isObjectEmpty(defenceData)}
                <div class="flex flex-1 w-full">Missing Defence Data.</div>
            {:else}
                <DisplayContent
                    title="PID No."
                    content={getText(defenceData.pid, "-")}
                />
                <DisplayContent
                    title="DAN No."
                    content={getText(defenceData.dan, "-")}
                />
            {/if}
        {:else if insuranceType == 30}
            {#if isSyncingPipData}
                <PageLoading />
            {:else if isObjectEmpty(pipData)}
                <div class="flex flex-1 w-full">
                    Missing Public in Private Data.
                </div>
            {:else}
                <DisplayContent
                    title="Email"
                    content={getText(pipData.email, "-")}
                />
                <DisplayContent
                    title="Vendor No."
                    content={getText(pipData.vendorNumbers, "-")}
                />
            {/if}
        {/if}
    {/if}
</div>
